<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0">Plan Details</h5>
                    <CButton color="primary" @click="goBack">Back to List</CButton>
                </CCardHeader>
                <CCardBody v-if="plan">
                    <CCard class="mt-2 shadow-sm">
                        <CCardHeader class="bg-info text-white">
                            <h6 class="mb-0">General Information</h6>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol md="6">
                                    <p><strong>Title:</strong> {{ plan.title }}</p>
                                    <p><strong>User Type:</strong> {{ plan.userType }}</p>
                                    <p><strong>Platform:</strong> {{ platformLabel(plan.platform) }}</p>
                                    <p><strong>Duration:</strong> {{ plan.durationValue }} {{ plan.durationUnit }}</p>
                                    <p><strong>Is Discounted Plan:</strong> <span v-if="plan.isOnetimeDiscountPlan == 0">No</span>
                                    <span v-else-if="plan.isOnetimeDiscountPlan == 1">Yes</span>
                                    <span v-else>-</span></p>
                                </CCol>
                                <CCol md="6">
                                    <p><strong>SKU Code:</strong> {{ plan.skuCode }}</p>
                                    <p><strong>Free Resume Count:</strong> {{ plan.freeResumeCount }}</p>
                                    <p><strong>Resume Count:</strong> {{ plan.resumeCount }}</p>
                                    <p><strong>Total Count:</strong> {{ plan.freeResumeCount+plan.resumeCount }}</p>
                                </CCol>
                                <CCol md="12">
                                    <p><strong>Description:</strong> {{ plan.description }}</p>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>

                    <!-- Prices -->
                    <CCard class="mt-3 shadow-sm" v-if="plan.prices && plan.prices.length">
                        <CCardHeader class="bg-warning text-dark">
                        <h6 class="mb-0">Prices</h6>
                        </CCardHeader>
                        <CCardBody>
                        <CRow v-for="price in plan.prices" :key="price.id" class="border-bottom pb-2 mb-2">
                            <CCol md="6">
                            <p><strong>Currency:</strong> {{ price.currency.currency_code }} ({{ price.currency.symbol }})</p>
                            <p><strong>Price:</strong> {{ price.price }}</p>
                            <p><strong>Offer Price:</strong> {{ price.offer_price }}</p>
                            <p><strong>Total Paid:</strong> {{ price.total_amount_paid_by_member }}</p>
                            </CCol>
                            <CCol md="6">
                            <p><strong>Platform Fee:</strong> {{ price.platform_fee }} ({{ price.platform_fee_percentage }}%)</p>
                            <p><strong>GST on Plan:</strong> {{ price.gst_on_plan }}</p>
                            <p><strong>GST % on Platform:</strong> {{ price.gst_percentage_on_platform }}%</p>
                            <p><strong>Base Plan Price:</strong> {{ price.base_plan_price }}</p>
                            </CCol>
                        </CRow>
                        </CCardBody>
                    </CCard>

                    <!-- Rules -->
                    <CCard class="mt-3 shadow-sm" v-if="plan.rules && plan.rules.length">
                        <CCardHeader class="bg-success text-white">
                        <h6 class="mb-0">Rules</h6>
                        </CCardHeader>
                        <CCardBody>
                        <ul>
                            <li v-for="rule in plan.rules" :key="rule.id">
                            {{ rule.title }}
                            </li>
                        </ul>
                        </CCardBody>
                    </CCard>
                </CCardBody>
                <CCardBody v-else>
                    <CAlert color="info" show>Loading scholarship details...</CAlert>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" @click="goBack">Back to List</CButton>
                    </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import { aiResumePlan } from '/src/store/url.js'; // Assuming you have your API paths here
import { Mixin } from '/src/mixins/index.js'; // Assuming you have a mixin with axios or data fetching logic
import store from "@/store/store"; // Assuming you use Vuex for global state/loader


export default {
    name: "AiResumePlanDetails",
    mixins: [Mixin], // Use your existing Mixin for API calls or utility methods
    data() {
        return {
            plan: null, // This will hold your fetched data
            id: this.$route.params.id, // Get ID from URL parameter
            module:aiResumePlan
        };
    },
    mounted() {
        // Show loader while fetching data
        store.commit('showLoader', true);
        this.fetchDetails();
    },
    methods: {
        platformLabel(val) {
        const mapping = { 0: "Web", 1: "Android", 2: "iOS" };
        return mapping[val] || val;
        },
        async fetchDetails() {
            try {
                axios.get(this.viewUrlApi(this.module, this.id))
                    .then(response => {
                        this.plan = response.data.data;
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        this.plan = null; // Clear data on error
                    });
            } catch (error) {
                console.error("API call failed:", error);
                this.plan = null; // Clear data on error
            } finally {
                // Hide loader after fetching, regardless of success or failure
                store.commit('showLoader', false);
            }
        },
        goBack() {
            // Adjust this route to your scholarship list page
            this.$router.push({ name: 'Resume Plan' })
        },
        formatDate(date) {
            if (!date) return 'N/A';
            return new Date(date).toLocaleDateString("en-IN", {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
    },
};
</script>

<style scoped>
/* Base styling from your example */
p {
    margin-bottom: 0.5rem;
}
h6 {
    margin-bottom: 0;
}
.shadow-sm {
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
.ml-1 {
    margin-left: 0.25rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.mb-3 {
    margin-bottom: 1rem;
}
.badge {
    font-size: 100% !important;
}
</style>